<script lang="ts">
import { getEnv } from '@monogrid/env'
import VersionInfo from '@monogrid/vue-boost/core/VersionInfo.vue'
import { defineComponent, inject, onMounted, shallowRef } from 'vue'

import shareImageTODOChangeMe from '@/assets/share.jpg'
import { setupHead } from '@/composables/useHead'
import { globalInjectionKeys } from '@/main'

import { COPY, DEFAULT_LOCALE } from './assets/locale/cherry/data'
import { delay, parseUrlQuery } from './utils'

declare global {
  interface Window {
    _satellite: { track: (code: string, params: object) => void }
  }
}

export default defineComponent({
  name: 'App',
  components: {
    VersionInfo
  },
  /**
   * Introduction
   *
   * https://v3.vuejs.org/guide/composition-api-introduction.html#basics-of-composition-api
   *
   * Setup functions
   * https://v3.vuejs.org/guide/composition-api-setup.html
   */
  setup (props, { attrs, slots, emit }) {
    const env = getEnv()
    const preloader = inject(globalInjectionKeys.preloader)
    const copy = shallowRef(COPY[DEFAULT_LOCALE])
    const show = shallowRef(window.location.pathname.indexOf('gallery') > -1)

    if (preloader) {
      preloader.visible = false
    }

    onMounted(async () => {
      const locale = parseUrlQuery().lang ? parseUrlQuery().lang : 'en'
      copy.value = locale && COPY[locale] ? COPY[locale] : COPY[DEFAULT_LOCALE]

      await delay(1)
      show.value = true
    })

    setupHead({
      siteName: () => 'Boilerplate',
      siteDescription: () => 'TODO: CHANGEME',
      defaultImage: () => `https://${env.SERVICE_TARGET_DOMAIN}${shareImageTODOChangeMe}`
    })

    return {
      env,
      copy,
      show
    }
  }
})
</script>

<template>
  <div class="app-container flex flex-auto relative flex-col items-center">
    <RouterView v-slot="{ Component, route }">
      <div v-show="route.name === 'Cherrific'" class="app-background" />
      <Transition mode="out-in">
        <!-- be careful with this key: it will transition all pages with different route names (not full paths) -->
        <component :is="Component" v-if="(!route.meta || (route.meta && route.meta.loadingChunk === false)) && Component" :key="route.name" class="page" />
        <!-- when page chunk is not loaded yet or component is not loaded yet, we display this -->
      </Transition>
    </RouterView>

    <!-- version info -->
    <VersionInfo v-if="env.SERVICE_STAGE === 'develop'" />
  </div>
</template>

<style lang="scss">
@use "@/styles/main";
</style>

<style lang="scss" scoped>
.app-container {
  @include svh(100, 'min-height');
}

.app-background {
  @include svh(100, 'min-height');
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background-image: url(@/assets/ui/cherry-background.jpg);
  background-size: cover;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  transition: opacity 0.6s;

  @media only screen and (max-width: 600px)  {
    background-image: url(@/assets/ui/cherry-background-mobile.jpg);
    background-size: 100% auto;
    background-position: 50% 0%;
    background-repeat: repeat-y;
  }
}
</style>
